import gql from 'graphql-tag'

export default gql`mutation updateEditProject($data: ProjectInput) {
    updateEditProject(data: $data) @client
}`